module.exports = __webpack_public_path__ + "img/online.21fb1f48.svg";